import { Group, Title } from "@mantine/core"

import { StatusBadge } from "~/components/Badge.tsx"

interface RequestTabHeaderProps {
  count: number
  label: string
  color?: string
}

export const RequestTabHeader = ({
  count,
  label,
  color = "red",
}: RequestTabHeaderProps) => {
  return (
    <Group>
      <StatusBadge color={color} value={count} />
      <Title order={4} fw={400}>
        {label}
      </Title>
    </Group>
  )
}
